import React from 'react'

import MenopauseAssessment from '@progyny/pages/Consultations/Menopause/MenopauseAssessment'
import MenopauseViewContent, {
  type MenopauseActiveTab,
} from '@progyny/pages/Consultations/Menopause/MenopauseViewContent'
import ConsultationPageLayout from '@progyny/pages/Consultations/components/ConsultationPageLayout'
import ConsultationRoutes from '@progyny/pages/Consultations/components/ConsultationRoutes'

const MenopauseViewWrapper: React.FC<{
  activeTab: MenopauseActiveTab
}> = ({activeTab}) => (
  <ConsultationPageLayout consultationSlug='menopause'>
    {(consultation, colors, theme, refetchConsultationDetail) => (
      <MenopauseViewContent
        consultation={consultation}
        colors={colors}
        theme={theme}
        activeTab={activeTab}
        onRefetchConsultationDetail={refetchConsultationDetail}
      />
    )}
  </ConsultationPageLayout>
)

const MenopauseOverview: React.FC = () => (
  <MenopauseViewWrapper activeTab='overview' />
)

const MenopauseConsultationPage: React.FC = () => {
  return (
    <ConsultationRoutes
      consultationSlug='menopause'
      assessmentComponent={MenopauseAssessment}
      overviewComponent={MenopauseOverview}
      upcomingPastView={({activeTab}) => (
        <MenopauseViewWrapper activeTab={activeTab} />
      )}
    />
  )
}

export default MenopauseConsultationPage
